import { useEffect, useRef, useState } from "react";
import { Button } from "./ui/button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "./ui/drawer";
import { PatternFormat } from "react-number-format";
import { Input } from "./ui/input";
import { LoaderCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ViewBuscarAtendimentos({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [valueCpf, setValueCpf] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRef?.current?.focus();
      }, 100);
    }
  }, [isOpen, inputRef]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    if (valueCpf) {
      navigate("/solicitacoes", { state: valueCpf })
    }
  };

  return (
    <Drawer onOpenChange={setIsOpen}>
      <DrawerTrigger asChild>{children}</DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Buscar solicitações</DrawerTitle>
          <DrawerDescription>Informe seu CPF para buscar suas solicitações.</DrawerDescription>
        </DrawerHeader>
        <form onSubmit={handleSubmit} className="">
          <div className="px-4">
            <PatternFormat
              disabled={loading}
              placeholder="Informe seu CPF"
              required
              format="###.###.###-##"
              name="cpf"
              id="cpf"
              autoComplete="cpf"
              type="tel"
              customInput={Input}
              onChange={(e) => setValueCpf(e.target.value)}
              value={valueCpf}
              getInputRef={inputRef}
            />
          </div>
          <DrawerFooter>
            <Button type="submit" disabled={!valueCpf || loading}>
              {loading && <LoaderCircle className="animate-spin text-slate-50 size-5" />}
              Buscar
            </Button>
            <DrawerClose asChild>
              <Button className="w-full" variant="outline">
                Cancelar
              </Button>
            </DrawerClose>
          </DrawerFooter>
        </form>
      </DrawerContent>
    </Drawer>
  );
}
